import React from 'react';
import { useGlobalPermission } from '../hooks/useGlobalPermission';

interface PermissionWrapperProps {
  permission: string;
  children: React.ReactNode;
}

export const PermissionWrapper: React.FC<PermissionWrapperProps> = ({ permission, children }) => {
  const hasPermission = useGlobalPermission();

  if (!hasPermission(permission)) {
    return null;
  }

  return <>{children}</>;
};